<!--
 * @Author: Smion Li
 * @Date: 2025-05-12 09:36:16
 * @LastEditTime: 2025-05-12 15:24:57
 * @LastEditors: Smion Li smion.li@mondoconnex.com
 * @Description: Venue Sub Group
 * @FilePath: /frontend-user/src/views/venue-sub-group/index.vue
-->
<style scoped lang="sass">
.app_container
  height: 100%

  ::v-deep

    .van-button--primary
      background-color: var(--menu-primary-background-colour)

    .van-loading
      color: var(--menu-primary-background-colour) !important

    .allergy
      max-height: calc(95vh - 70PX)

      .app_container
        padding: 31px 26px 26px 27px

        .title
          left: 0PX
          width: 100%
          font-size: 22PX
          font-weight: bold

      .allergy_content
        width: 242px

        .allergy_text
          margin: 26px 0 21px 0
          text-align: center
          font-size: 15px
          color: #334455

        .allergy_img
          display: flex
          justify-content: center

          .img
            width: 57px

        .allergy_btn
          height: 56px
          font-size: 15px

  .top
    height: 56PX
    width: 100%
    /* UI Properties */
    background: #000000 0% 0% no-repeat padding-box
    opacity: 1
    display: flex
    align-items: center
    justify-content: space-between
    align-content: center

    .action_btn
      width: 30px
      height: 30px
      display: flex
      align-items: center
      justify-content: center
      cursor: pointer

    .left_actions
      display: flex
      align-items: center
      margin-left: 4px
      min-width: 34px

    .title
      flex: 1
      text-align: center
      font-size: 20PX
      font-weight: bold
      letter-spacing: 0.21PX
      color: #FFFFFF
      opacity: 1
    .right_actions
      display: flex
      align-items: center
      margin-right: 8px
      min-width: 60px
      justify-content: flex-end
      gap: 4px

  .head
    position: relative
    display: flex
    flex-direction: column
    align-items: center
    height: 136PX
    box-shadow: 0px 2px 6px rgba(51, 68, 85, 0.08)
    background-color: #fff

    .logo
      width: 100%
      height: 136PX
      object-fit: cover
      text-align: center
      vertical-align: middle

    .title
      margin-top: 13px
      font-size: 16px
      line-height: 16px
      font-weight: bold
      line-height: 19px
      color: rgba(51, 68, 85, 1)

    .text
      margin-top: 7px
      font-size: 12px
      line-height: 14px
      color: rgba(51, 68, 85, 1)

  .body
    flex: 1
    overflow-y: auto
    display: flex
    flex-direction: column
    align-items: center
    padding: 20PX 16PX 20PX 16PX
    background: #F0F1F2 0% 0% no-repeat padding-box
    margin-bottom: 40PX
    overflow-x: hidden

    .venue_section
      width: 100%
      margin: 10PX 30PX
      border-radius: 4PX
      background-color: #fff

      .banner
        line-height: 0PX
        background-color: #fff
        position: relative
        display: inline-block

        .img
          display: block
          border-radius: 4PX
          width: 100%
          line-height: 0PX
        .mask
          position: absolute
          left: 0
          top: 0
          bottom: 0
          width: 100%
          background-color: #000000
          border-radius: 4px
          z-index: 1
          opacity: 0.7
        .mask_text
          background: #B00620 0% 0% no-repeat padding-box
          border-radius: 9px
          position: absolute
          top: 10px
          left: 5px
          font: normal normal bold 10px/13px Roboto
          letter-spacing: 0.3px
          color: #FFFFFF
          text-transform: uppercase
          display: flex
          flex-wrap: nowrap
          justify-content: center
          align-items: center
          z-index: 1
          height: 22PX
          width: 100PX

      .banner.disable::after
        content: ''
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        background: rgba(128, 128, 128, 0.5)
        pointer-events: none

      .name
        font-size: 14PX
        font-weight: bold
        background-color: #fff
        line-height: 30PX
        text-align: left
        padding-left: 10PX
        padding-right: 5PX
        border-bottom-left-radius: 4PX
        border-bottom-right-radius: 4PX

    ::v-deep
      .dishes_list
        height: 70px

      .infos_border
        border: none

  .footer
    height: 56px

  .total
    font-size: 15px
    //color: #fff

    .price
      font-weight: bold
</style>

<style lang="sass" scoped>
.icon
  flex: 1
  display: flex
  justify-content: center
  align-items: center

.pic
  height: 150px
  width: 150px
</style>

<template lang="pug">
  .app_container
    .top
      .left_actions
        .action_btn(@click="jumpToOrderHistory")
          icon(size="24" color="#FFFFFF") receipt_long
      .title {{ venueGroupName }}
      .right_actions
        .action_btn(v-if="hasMultipleLanguages" @click="showLanguageModal = true")
          icon(size="22" color="#FFFFFF") translate
        .action_btn(v-if="hasMultipleCurrencies" @click="showCurrencyModal = true")
          icon(size="22" color="#FFFFFF") currency_exchange

    .head
      img.logo(:src="logo")
      //span.title Welcome to {{ venueGroupName }}
      //p.text To begin an order, select one of our venues below
    .body(v-if="venueList.length > 0")
      .venue_section(v-for="venue in venueList" @click="jumpToVenue(venue)")
        .banner
          img.img(v-lazy="getImg(venue.logo)")
          .mask(v-if="!venue.isOpen")
          .mask_text(v-if="!venue.isOpen") {{ t('unavailable', 'UNAVAILABLE') }}
        .name {{ getVenueName(venue) }}
    .icon(v-if="venueList.length === 0 && !showLoading")
      svg-icon.pic(
        :color="color"
        icon-class="No_venues-01"
      )
    footer-bar.footer_bar_absolute(
      v-show="hasProduct"
      :status='4',
      :disabled='!isVenueOpenTime || hasExpireProduct',
      @clickButton='jumpToCart'
    )
      template(v-slot:left)
        .total {{ t('order_total', 'Order total:') }}
          span.price.ls1 {{ symbolPosition === 'after' ? ' ' : ' ' + currencySymbol }}{{ cvt(total) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
    bottom-popup-dialog.allergy(
      v-model="showPopupMessage"
      position="center"
      :title="t('welcome', 'Welcome!')"
      :showCloseIcon="false"
      @changeShow="showPopupMessage = false"
    )
      template(v-slot:popup-dialog)
        .allergy_content
          .allergy_text(v-html="renderRichText(popupText)")
          van-button.allergy_btn.b.ls1(type="primary" block @click="showPopupMessage = false") {{ t('ok', 'OK') }}
    language-selector-modal(
      :show="showLanguageModal"
      :languages="supportedLanguages"
      :currentLanguage="currentLanguage"
      @select="selectLanguage"
      @close="showLanguageModal = false"
    )
    currency-selector-modal(
      :show="showCurrencyModal"
      :currencies="supportedCurrencies"
      :currentCurrency="currentCurrencyCode"
      @select="selectCurrency"
      @close="showCurrencyModal = false"
    )
</template>

<script>
import dayjs from 'dayjs'
import Vue from 'vue'
import Component from 'vue-class-component'
import { getVenueGroup, getUserOrders } from 'api/product'
import { _getNowOperatingHours, _weeklyOperatingHours } from 'utils'
import { _getDefaultProductsImg } from 'utils/defaultProductsImg'
import { _hexToRgb } from '../../utils/format'
import { t, getLocalizedField, getLocalizedCustomMessage } from '@/utils/language'
import { sanitizeRichText } from '@/utils/richtext/sanitizeRichText'
import { richTextHasContent } from '@/utils/richtext/richTextContent'
import { getCurrencySymbol, getSymbolPosition, formatDecimalNumber, convertPrice } from '@/utils/currency'
import { saveLocalePrefs } from '@/store/modules/language'
import { mapGetters, mapState } from 'vuex'
import LanguageSelectorModal from '@/components/LocaleSelector/LanguageSelectorModal.vue'
import CurrencySelectorModal from '@/components/LocaleSelector/CurrencySelectorModal.vue'

@Component({
  components: {
    LanguageSelectorModal,
    CurrencySelectorModal,
  },
  props: {
    venueSubGroupId: String
  },
  created() {
    this.$store.commit('showLoading')
    this.fromQR = this.$route?.query?.fromQR
    if (this.fromQR) {
      // 先用 replace 去掉 fromQR 参数，替换当前历史
      const queryCopy = { ...this.$route.query }
      delete queryCopy.fromQR
      this.$router.replace({ path: this.$route.path, query: queryCopy })
    }
    this.getData()
  },
  computed: {
    ...mapState('language', {
      currentLanguage: 'currentLanguage',
      supportedLanguages: 'supportedLanguages',
    }),
    ...mapGetters('language', ['hasMultipleLanguages']),
    ...mapState('currencySettings', {
      currentCurrencyCode: 'currentCurrency',
      supportedCurrencies: 'supportedCurrencies',
    }),
    ...mapGetters('currencySettings', ['hasMultipleCurrencies']),
    showLoading() {
      return this.$store.state.showLoading
    },
    total() {
      return this.$store.getters.subGroupCartTotal()
    },
    userId() {
      return localStorage.getItem('userId')
    },
    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },
    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },
    currentCurrency() {
      return this.$store.state.currencySettings?.currentCurrency
    }
  },
  filters: {
    fix(val) {
      return formatDecimalNumber(val)
    },
  },
})
class VenueGroupSubList extends Vue {
  color = 'rgba(20, 196, 188, 1)'
  venueGroupType = 'subGroup'
  venueGroupDetail = {}
  number = null
  venueGroupName = ''
  venueList = []
  logo = ''
  noPicImg = require('@/assets/defaultProductsImg/Food.jpg')
  fromQR = false

  isVenueOpenTime = true
  hasExpireProduct = false
  hasProduct = false
  showPopupMessage = false
  popupText = t('sub_group_popup_text', 'You can order from multiple venues in a single order. You will receive pick-up instructions for each venue after placing your order.')
  tableList = []

  // Language/Currency modal state / 语言货币弹窗状态
  showLanguageModal = false
  showCurrencyModal = false

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  // 欢迎弹窗文案可能是管理端富文本编辑器产出的 HTML(<p>/&nbsp; 等)。
  // 净化后 v-html 渲染,避免把标签当纯文本原样显示给顾客,同时挡住存储型 XSS。
  renderRichText(html) {
    return sanitizeRichText(html)
  }

  /**
   * Convert price to display currency / 转换价格到显示货币
   * References this.currentCurrency for Vue reactivity / 引用 this.currentCurrency 以实现 Vue 响应式
   */
  cvt(price) {
    // eslint-disable-next-line no-unused-vars
    const _currency = this.currentCurrency
    return convertPrice(price)
  }

  /**
   * Get localized venue name / 获取本地化的餐厅名称
   */
  getVenueName(venue) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return getLocalizedField(venue, 'name') || venue.name
  }

  /**
   * Select language and propagate to all venues in sub-group
   * 选择语言并传播到 sub-group 中所有 venue
   */
  selectLanguage(langCode) {
    this.$store.dispatch('language/changeLanguage', {
      lang: langCode,
      venueId: this.venueSubGroupId,
    })
    // Propagate language to all venues in sub-group / 传播语言设置到 sub-group 中所有 venue
    if (this.venueList && this.venueList.length > 0) {
      for (const venue of this.venueList) {
        saveLocalePrefs(venue.id, 'language', langCode)
      }
    }
    this.showLanguageModal = false
  }

  /**
   * Select currency and propagate to all venues in sub-group
   * 选择货币并传播到 sub-group 中所有 venue
   */
  selectCurrency(currCode) {
    this.$store.dispatch('currencySettings/changeCurrency', {
      currency: currCode,
      venueId: this.venueSubGroupId,
    })
    // Propagate currency to all venues in sub-group / 传播货币设置到 sub-group 中所有 venue
    if (this.venueList && this.venueList.length > 0) {
      for (const venue of this.venueList) {
        saveLocalePrefs(venue.id, 'currency', currCode)
      }
    }
    this.showCurrencyModal = false
  }

  jumpToCart() {
    if (this.number) {
      this.$router.push(`/vgs/${this.venueSubGroupId}/cart/t/${this.number}?fromPortal=true`)
    } else {
      this.$router.push(`/vgs/${this.venueSubGroupId}/cart/p?fromPortal=true`)
    }
  }

  async getData() {
    if (this.venueSubGroupId === 'elr_test') {
      this.logo = process.env.VUE_APP_BASE_API + '/img/other/sub_group_test2.png?v=1'
    }

    const res = await getVenueGroup({
      id: this.venueSubGroupId,
      type: this.venueGroupType
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    if (res.logo && res.logo.length > 0) {
      this.logo = res.logo
    }

    this.venueList = res.venues
    this.venueGroupDetail = { ...res }
    this.tableList = res.tableList ?? []
    this.validateVenueOpenTime()
    // this.logo = res.logo
    this.venueGroupName = res.name
    if (this.venueList && this.venueList.length > 0) {
      this.$store.commit('saveSubGroupId', this.venueSubGroupId)
      // console.log(this.venueList.length)
      this.$store.commit('saveSubGroupVenueList', this.venueList)
    }
    this.hasProduct = this.$store.getters.subGroupCartHasProduct()

    document.body.style.setProperty('--menu-primary-background-colour', '#000000')
    document.body.style.setProperty('--menu-primary-background-colour-rgb', _hexToRgb('#000000'))

    // save to store
    this.$store.commit('saveSubgroupSetting', {
      id: this.venueSubGroupId,
      name: 'settings',
      setting: this.venueGroupDetail?.settings ?? {}
    })

    // Initialize language settings from sub-group API response
    // 从 sub-group API 响应初始化语言设置
    this._initLanguageSettings(this.venueGroupDetail)

    // Initialize currency settings from sub-group API response
    // 从 sub-group API 响应初始化货币设置
    this._initCurrencySettings(this.venueGroupDetail)

    // Track session locale after initialization / 初始化后记录会话语言和货币
    this._trackSessionLocale()

    // check user has un-closed order, go to order history if there it is
    if (this.userId && this.fromQR) {
      const res = await this._getUserUnOverOrders('notstart')
      const orderTotal = res.orders.length
      // console.log(orderTotal)

      if (orderTotal >= 1) {
        for (let i = 0; i < parseInt(res.total); i++) {
          const hasUnfinishOrder = this._checkUnfinishOrder(res.orders[i])
          if (hasUnfinishOrder) break
        }
      }
    }

    this.$store.commit('closeLoading')

    // save popup message behavior
    if (this.venueGroupDetail?.settings?.customMessageSettings?.enable) {
      const customMessage = getLocalizedCustomMessage(this.venueGroupDetail?.settings?.customMessageSettings, 'message')
      // 只在自定义欢迎语真有可见内容时才覆盖默认文案;空 / 只剩 <p>&nbsp;</p> 之类残留时保留默认。
      this.popupText = richTextHasContent(customMessage) ? customMessage : this.popupText
      const currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '')
      if (this.$store.state.venueHome.subGroupSettings[this.venueSubGroupId]?.showPopupMessage) {
        if (currentDate !== this.$store.state.venueHome.subGroupSettings[this.venueSubGroupId]?.showPopupMessage) {
          this.showPopupMessage = true
          this.$store.commit('saveSubgroupSetting', {
            id: this.venueSubGroupId,
            name: 'showPopupMessage',
            setting: currentDate
          })
        }
      } else {
        this.showPopupMessage = true
        this.$store.commit('saveSubgroupSetting', {
          id: this.venueSubGroupId,
          name: 'showPopupMessage',
          setting: currentDate
        })
      }
    }

    // noAlcohol filter:QR 带 filterRule=noAlcohol 或 noAlcohol=1 时存为子分组设置(跨 venue 切换存活);
    // 否则在新 QR 进入时重置。venue-home 会从 subGroupSettings 读出并应用。
    const filterRule = this.$route?.query?.filterRule
    const naFromUrl = this.$route?.query?.noAlcohol === '1' ||
      (typeof filterRule === 'string' && filterRule.split(',').map(s => s.trim()).includes('noAlcohol'))
    if (naFromUrl) {
      this.$store.commit('saveSubgroupSetting', {
        id: this.venueSubGroupId,
        name: 'noAlcohol',
        setting: true
      })
    } else if (this.fromQR) {
      this.$store.commit('saveSubgroupSetting', {
        id: this.venueSubGroupId,
        name: 'noAlcohol',
        setting: false
      })
    }
  }

  validateVenueOpenTime() {
    for (const venue of this.venueList) {
      const posStatus = venue.settings?.posStatus ?? null
      if (posStatus && posStatus.enable && posStatus.status !== 1) {
        venue.isOpen = false
        venue.posOpen = false
      } else {
        // check open time
        if (!venue.isOpen) {
          venue.isOpen = false
        }
      }
    }
  }

  /**
   * Initialize language settings from sub-group API response
   * 从 sub-group API 响应初始化语言设置
   *
   * @param {Object} groupDetail - Sub-group detail object / Sub-group 详情对象
   */
  _initLanguageSettings(groupDetail) {
    const languageSettings = groupDetail?.settings?.languageSettings || null
    this.$store.dispatch('language/initLanguageSettings', {
      apiSettings: languageSettings,
      venueId: this.venueSubGroupId,
    })
  }

  /**
   * Initialize currency settings from sub-group API response
   * 从 sub-group API 响应初始化货币设置
   *
   * @param {Object} groupDetail - Sub-group detail object / Sub-group 详情对象
   */
  _initCurrencySettings(groupDetail) {
    let currencySettings = groupDetail?.settings?.currencySettings || null

    // Handle case where currencySettings is a string (just currency code)
    // 处理 currencySettings 是字符串（仅货币代码）的情况
    if (typeof currencySettings === 'string') {
      currencySettings = {
        defaultCurrency: currencySettings,
      }
    }

    this.$store.dispatch('currencySettings/initCurrencySettings', {
      apiSettings: currencySettings,
      venueId: this.venueSubGroupId,
    })
  }

  /**
   * Track session locale (language + currency) after initialization
   * 初始化后上报会话语言和货币
   */
  _trackSessionLocale() {
    const sessionLang = this.$store.state.language.currentLanguage
    const sessionCurrency = this.$store.state.currencySettings?.currentCurrency || 'AUD'
    if (this.$openreplayTracker) {
      this.$openreplayTracker.event('session_locale', { language: sessionLang, currency: sessionCurrency })
    }
    if (this.$gtag) {
      this.$gtag.event('session_locale', {
        event_category: 'user_preference',
        event_label: `${sessionLang} / ${sessionCurrency}`,
        language: sessionLang,
        currency: sessionCurrency,
      })
    }
  }

  jumpToVenue(venue) {
    if (venue.isOpen) {
      const id = venue.id
      this.chooseVenueId = id
      // Propagate current language/currency to the target venue
      // 将当前语言/货币设置传播到目标 venue
      const currentLang = this.$store.state.language?.currentLanguage
      const currentCurr = this.$store.state.currencySettings?.currentCurrency
      if (currentLang) {
        saveLocalePrefs(id, 'language', currentLang)
      }
      if (currentCurr) {
        saveLocalePrefs(id, 'currency', currentCurr)
      }
      this.$router.push(`/v/${this.chooseVenueId}/home/p?subGroupId=${this.venueSubGroupId}&fromP=1`)
    }
  }

  jumpToOrderHistory() {
    this.$router.push(`/vgs/${this.venueSubGroupId}/order-history`)
  }

  _getTime(hour) {
    if (hour && ((hour.fromHour && hour.toHour) || hour?.hourSettings?.length)) {
      try {
        const [fromHour, fromMin] = hour.fromHour.split(':')
        const [toHour, toMin] = hour.toHour.split(':')
        return [fromHour, fromMin, toHour, toMin]
      } catch {
        return false
      }
    }
  }

  getOperationHours(data) {
    const {
      todayOperatingHours,
      weeklyOperatingHours
    } = data
    const closeText = t('not_set_open_time', 'not set open time yet')
    // 没有匹配到营业时间段，就展示闭店的文案
    if (!this._getTime(todayOperatingHours)) return closeText
    if (todayOperatingHours?.hourSettings?.length) {
      // 有 hourSettings 时，用多段时间的方法判断
      const time = _weeklyOperatingHours(weeklyOperatingHours, false, 0, true)
      return time || closeText
    } else {
      // 没有 hourSettings 时，用旧的单段时间的方法判断
      const [fromHour, fromMin, toHour, ToMin] = this._getTime(todayOperatingHours)
      const from = dayjs(`2019-01-25 ${fromHour}:${fromMin}`).format('hh:mma')
      const to = dayjs(`2019-01-25 ${toHour}:${ToMin}`).format('hh:mma')
      return from + ' - ' + to
    }
  }

  getImg(imgUrl) {
    // Compatible with dirty data, when imgUrl has no value
    // 兼容脏数据，'imgUrl' 没有值的情况
    if (!imgUrl) return this.noPicImg
    // Judge whether the image url is the default image type
    // 判断图片 url 是否是默认图片类型
    const isDefaultProductsImg = imgUrl.includes('/img/product/')
    return isDefaultProductsImg ? _getDefaultProductsImg(imgUrl) : imgUrl
  }

  getVenueOpenTime(dateInfo) {
    // 餐厅是否营业的开关
    const { enable } = { ...dateInfo.todayOperatingHours }
    // 餐厅是否在营业时间
    const timeOver = dateInfo.todayOperatingHours ? !!_getNowOperatingHours(dateInfo.todayOperatingHours) : false
    return enable && timeOver
  }

  /**
   * 获取 user 下的 orders
   *  type 默认为 all
   *    close 为只展示已经完成的 order
   *    notstart 则为制作还未完成
   *    nostart_all 显示包括未付款且制作未完成的
   */
  async _getUserUnOverOrders(type) {
    const res = await getUserOrders({
      venueId: 'all',
      venueSubGroupId: this.venueSubGroupId,
      id: this.userId,
      type: type,
      pageSize: 5,
      pageNo: 1
    }).catch(error => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  // 根据订单 type 做出相应跳转
  _checkUnfinishOrder(order) {
    let hasUnfinishOrder
    const notOverOrderNo = order?.orderNo ?? ''
    const notOverOrderId = order?.id ?? ''
    const paymentStatus = order?.paymentStatus ?? ''
    const type = order?.type ?? ''
    const status = order?.status ?? ''

    const STATUS_ORDER_FINISH = 30
    const PAYMENT_TYPE = {
      POST_PAID_PAYMENTTYPE: 2,
      PRE_PAID_PAYMENTTYPE: 0
    }
    const PAYMENT_STATUS = {
      START: 0,
      SUCCESS: 1,
      FAILED: 2,
      PENDING: 3,
      REFUND: 4,
      REFUND_ERROR: 5
    }
    // const isUrlTypeOrder = this._isUrlTypeOrder(order)
    // 若此订单不符合当前链接模式，停止继续运行
    // if (!isUrlTypeOrder) return hasUnfinishOrder

    if (type === PAYMENT_TYPE.POST_PAID_PAYMENTTYPE) {
      // post-paid
      // 判断是否付款完成，完成则跳转到 my-order，未支付跳转到 pay
      if (paymentStatus === PAYMENT_STATUS.SUCCESS) {
        // 支付完成
        // 支付完成，且 order 完成
        if (status >= STATUS_ORDER_FINISH) {

        } else {
          // 支付完成，但 order 未完成
          // QR 扫码重定向不带 isMarketing，避免 campaign 重复显示
          this.$router.push({
            path: `/vgs/${this.venueSubGroupId}/order-status/${notOverOrderId}`,
            query: {
              orderNo: notOverOrderNo,
            }
          })
        }
      }
    } else if (type === PAYMENT_TYPE.PRE_PAID_PAYMENTTYPE) {
      // pre-paid
      if (paymentStatus === PAYMENT_STATUS.SUCCESS) {
        // 支付完成 pre-paid
        // 支付完成，order 已完成
        if (status >= STATUS_ORDER_FINISH) {

        } else {
          // 支付完成，但是 order 未完成
          // QR 扫码重定向不带 isMarketing，避免 campaign 重复显示
          this.$router.push({
            path: `/vgs/${this.venueSubGroupId}/order-status/${notOverOrderId}`,
            query: {
              orderNo: notOverOrderNo,
            }
          })
        }
      } else {
        // 支付未完成 pre-paid
      }
    } else if (type === PAYMENT_STATUS.REFUND) {
      // refund
    }
    return hasUnfinishOrder
  }
}

export default VenueGroupSubList
</script>
